import {createApp, App} from 'vue';
import Planbord from '@/components/Planbord.vue';

declare global {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    interface Window {
        MSStream: any;
    }

    /* eslint-enable @typescript-eslint/no-explicit-any */
}

const app: App = createApp(Planbord);

app.mount('#app');
